export const ErrorMessages = {
    TransactionFees: 'Please share the Transaction fees.',
    TransactionWithOtherDealer: 'Please share the Amount with other dealers.',
    PanNo: 'The entered PAN number is invalid. Please input the correct PAN.',
    ProductName: 'Please select the Product.',
    ProductType: 'Please select the Purpose.',
    CurrencyCode: 'Please select the Currency.',
    DefinedRate: 'Please enter the Rate.',
    FxAmount: 'Please share the Forex Amount.',
    MultiMissing: 'Please fill in all the required details.',
    LossMessage: 'Please input the correct Rate to avoid making loss.'
}